import { logger } from "./shared/logger";
import { Resolve } from "./transport/response";

export function onCancel(callback: (() => void) | undefined): void {
	window._cancel = callback ?? onCancel.default;
}

onCancel.default = () => {
	logger.debug("cancel: default called");
	return void Resolve.Error("Cancelled");
};
